// components/Image.js
import NextImage, { ImageProps } from "next/image";

// opt-out of image optimization, no-op
export const customLoader = ({ src }: { src: string }) => {
  return src;
};

// interface style dom props

export default function Image(
  props: ImageProps & { style?: Record<string, string> }
) {
  if (!props.src) {
    return null;
  }

  /**
   * @NOTE The next image component doesn't accept a style attribute, but some
   * consumers of this component aren't following the rules!
   *
   * @Ref https://github.com/akiran/react-slick/blob/master/src/slider.js#L175
   * In this particular 3rd party component (react-slick), note the use of
   * cloneElement and the addition of a `style` property. This allows a 3rd party
   * component to add any properties they like. In this case, it is an error
   * because the component react-slick is cloning does not accept a `style`
   * property.
   *
   * The fix below removes any overidden style property that may have been added
   * using a technique like the one above.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { style, ...remaining } = props;
  return <NextImage {...remaining} unoptimized={true} loader={customLoader} />;
}
